import {newRequest} from '@/utils/request'

// 列表
export const getList = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/admin/search', params)

// 禁用账号
export const isDisable = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/admin/disable', params)

// 启用账号
export const isEnable = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/admin/enable', params)

// 添加账号
export const add = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/admin/add', params)

// 修改账号
export const update = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/admin/update', params)

// 账号详情
export const details = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/admin/query', params)

// 查询账号角色
export const roleByid = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/admin/queryRole', params)

// 查询平台角色
export const roleByappId = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/role/querylist', params)

// 账号授权角色
export const authorize = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/admin/authorize', params)
